module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp13_0.c9c3d3ed.png";